import { FadeUp } from "./Reveal";
import { scrollToSection } from "./Nav";
import Logo from "./Logo";
import { Link } from "react-router-dom";
import StoreBadges from "./StoreBadges";

export default function Footer() {
  return (
    <footer className="bg-[#0A130B] text-[#EAE5D9] px-6 md:px-12 pt-24 md:pt-32 pb-10" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto">
        <FadeUp>
          <div className="flex items-start gap-4">
            <Logo testid="footer-logo" className="h-11 w-11 shrink-0 mt-2" />
            <p className="font-serif font-light tracking-tight leading-[0.95] text-[13vw] md:text-[7rem]">
              My Fresh <em className="text-[#1F9D55]">Tracker</em>
            </p>
          </div>
        </FadeUp>
        <FadeUp delay={0.1}>
          <StoreBadges idPrefix="footer" className="mt-12" />
        </FadeUp>
        <div className="mt-16 md:mt-24 pt-8 border-t border-[#EAE5D9]/20 flex flex-col md:flex-row md:items-center justify-between gap-6">
          <p className="text-sm text-[#EAE5D9]/60">© 2026 My Fresh Tracker. Freshness, tracked.</p>
          <div className="flex items-center gap-8">
            {[
              ["features", "Features"],
              ["support", "Support"],
            ].map(([id, label]) => (
              <button
                key={id}
                onClick={() => scrollToSection(id)}
                data-testid={`footer-${id}-link`}
                className="uppercase tracking-[0.2em] text-xs font-semibold text-[#EAE5D9]/70 hover:text-[#F2C94C] transition-colors duration-300"
              >
                {label}
              </button>
            ))}
            <Link
              to="/terms"
              data-testid="footer-terms-link"
              className="uppercase tracking-[0.2em] text-xs font-semibold text-[#EAE5D9]/70 hover:text-[#F2C94C] transition-colors duration-300"
            >
              Terms
            </Link>
            <Link
              to="/privacy"
              data-testid="footer-privacy-link"
              className="uppercase tracking-[0.2em] text-xs font-semibold text-[#EAE5D9]/70 hover:text-[#F2C94C] transition-colors duration-300"
            >
              Privacy
            </Link>
            <Link
              to="/delete-account"
              data-testid="footer-delete-account-link"
              className="uppercase tracking-[0.2em] text-xs font-semibold text-[#EAE5D9]/70 hover:text-[#F2C94C] transition-colors duration-300"
            >
              Delete account
            </Link>
          </div>
          <a
            href="mailto:support@myfreshtracker.app"
            data-testid="footer-email-link"
            className="text-sm text-[#EAE5D9]/70 hover:text-[#F2C94C] transition-colors duration-300"
          >
            support@myfreshtracker.app
          </a>
        </div>
      </div>
    </footer>
  );
}
